<div class="indicator-container rounded-circle" [ngClass]="{'top-right' : !position, position : position}">
  <div class="indicator avitium-bg-color rounded-circle" [ngClass]="{size: size}">
    &nbsp;
  </div>
</div>
